/**
 * Renders the model's answer.
 *
 * `react-markdown` builds React elements from the markdown AST. It never produces
 * an HTML string and never touches `innerHTML`, so there is no injection surface to
 * sanitise in the first place. Raw HTML passthrough (`rehype-raw`) is deliberately
 * not installed: the answer text derives from documents users upload, so treating
 * it as trusted markup is exactly the mistake being corrected. The previous client
 * passed `marked` output (version 0.3.5, from 2015) straight into
 * `dangerouslySetInnerHTML`.
 */

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import "./markdown.css";

export function Markdown({ children }: { children: string }) {
  return (
    <div className="md">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // External links open in a new tab, and rel prevents the opened page
          // from reaching back into this one.
          a: ({ href, children: label }) => (
            <a href={href} target="_blank" rel="noreferrer noopener">
              {label}
            </a>
          ),
          table: ({ children: rows }) => (
            <div className="md-table-scroll">
              <table>{rows}</table>
            </div>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
